import React from 'react';
import { useIntl, FormattedMessage } from 'react-intl';
import { Form, Modal, Button } from 'antd';
import { useRouteMatch } from 'react-router';

import RatesForm from '../RatesForm';
import { useCreateDocumentTypeRate } from '@/core/domain/enterprise/DocumentTypeRates/DocumentTypeRates.hooks';
import { DocumentTypeRateFormValues } from '@/core/domain/enterprise/DocumentTypeRates/DocumentTypeRates.types';

interface Props {
  visible: boolean;
  onCancel: VoidFunction;
  ratesLength: number;
}

function CreateRateModal({ visible, onCancel, ratesLength }: Props) {
  const intl = useIntl();
  const [form] = Form.useForm<DocumentTypeRateFormValues>();
  const { documentTypeId } = useRouteMatch<{ documentTypeId: string }>().params;

  const createMutation = useCreateDocumentTypeRate(Number(documentTypeId));

  function handleOnCancel() {
    form.resetFields();
    onCancel();
  }

  async function handleOnSave() {
    try {
      const values = await form.validateFields();
      const installments = values.numberInstallments + ratesLength;
      const result = [];

      for (let i = ratesLength; i < installments; i += 1) {
        result.push({
          numberInstallments: i + 1,
          percentRate: values.percentRate,
        });
      }

      await createMutation.mutateAsync(result);

      handleOnCancel();
    } catch {}
  }

  const footer = [
    <Button key={0} type="primary" ghost onClick={onCancel}>
      <FormattedMessage id="commons.form.button.close" />
    </Button>,
    <Button
      key={1}
      type="primary"
      onClick={handleOnSave}
      loading={createMutation.isLoading}
    >
      <FormattedMessage id="commons.form.button.save" />
    </Button>,
  ];

  return (
    <Modal
      width={680}
      open={visible}
      onCancel={onCancel}
      title={intl.formatMessage({
        id: 'documentTypes.rate.modal.create.title',
      })}
      footer={footer}
    >
      <RatesForm form={form} />
    </Modal>
  );
}

export default CreateRateModal;
